import { render, staticRenderFns } from "./FormResidentialPhoto.vue?vue&type=template&id=49cb6678&scoped=true&lang=pug&"
import script from "./FormResidentialPhoto.vue?vue&type=script&lang=js&"
export * from "./FormResidentialPhoto.vue?vue&type=script&lang=js&"
import style0 from "./FormResidentialPhoto.vue?vue&type=style&index=0&id=49cb6678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cb6678",
  null
  
)

export default component.exports